export default __webpack_public_path__ + "static/media/KHANH.3bd13bc2.png";